/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: ESM Woocommerce to Hubspot Integration
  Author: Wibert Muza
  Agency URL: https://esminbound.com
==========================================================================================*/

import axios from "@/http/axios/index.js";

const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit("UPDATE_STARRED_PAGE", payload);
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit("TOGGLE_CONTENT_OVERLAY");
  },
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val);
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit("UPDATE_USER_INFO", payload);
  },

  updateUserData({ commit, state }) {
    const userInfo = state.AppActiveUser.uid;
    //console.log('userInfo ', state.AppActiveUser.uid)
    axios
      .get(
        `https://us-central1-app-script-243110.cloudfunctions.net/fetch_hubspot_connection_data?userId=${userInfo}`
      )
      .then(response => {
        if ("error" in response.data) {
          commit("UPDATE_USER_INFO", {
            hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${userInfo}`,
            woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${userInfo}`
          });
        } else {
          commit("UPDATE_USER_INFO", {
            hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${userInfo}`,
            woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${userInfo}`,
            cards: response.data,
            received: true
          });
        }
      })
      .catch(() => {
        commit("UPDATE_USER_INFO", {
          hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${userInfo}`,
          woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${userInfo}`
        });
      });
  },

  updateMappingsData({ commit, state }, payload) {
    axios
      .post(
        `https://us-central1-app-script-243110.cloudfunctions.net/fetch_hubspot_connection_data?userId=${state.AppActiveUser.uid}&action=setmappings`,
        payload
      )
      .then(response => {
        commit("UPDATE_USER_INFO", { updateSendData: response.data });
      })
      .catch(error => {
        console.log("Error sent to db", error);
      });
  },

  updateConnectionSendData({ commit, state }, payload) {
    axios
      .post(
        `https://us-central1-app-script-243110.cloudfunctions.net/fetch_hubspot_connection_data?userId=${state.AppActiveUser.uid}&action=appstatus`,
        payload
      )
      .then(response => {
        commit("UPDATE_USER_INFO", { updateSendData: response.data });
      })
      .catch(error => {
        console.log("Error sent to db", error);
      });
  }
};

export default actions
